module.exports = __webpack_public_path__ + "static/img/cell_doc.0e7c666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cell_doc.png
// module id = 59FS
// module chunks = 1